import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Marquee() {
  const items = [
    "HUDAK ENTERPRISES",
    "MADE IN BERN",
    "SEIT 2026",
    "SCHWEIZER QUALITÄT",
    "FESTPREISE",
    "KEIN OUTSOURCING",
  ];
  const row = [...items, ...items, ...items];

  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [0.92, 1.03, 0.98]);
  const skewY = useTransform(scrollYProgress, [0, 1], [-2, 2]);
  const trackX2 = useTransform(scrollYProgress, [0, 1], ["0%", "-30%"]);

  return (
    <section
      ref={ref}
      aria-hidden="true"
      className="bg-[#FAFAF7] py-20 md:py-28 border-t border-b border-black/10 overflow-hidden"
    >
      <motion.div style={{ scale, skewY }} className="origin-center will-change-transform">
        <div className="marquee-track font-serif-editorial text-[14vw] md:text-[10vw] leading-none tracking-tight text-[#0A0A0A]/95">
          {row.map((t, i) => (
            <span key={i} className="flex items-center gap-16">
              <span className={i % 2 === 1 ? "italic text-[#C9A961]" : ""}>{t}</span>
              <span className="text-[#C9A961]">✦</span>
            </span>
          ))}
        </div>
        <motion.div
          style={{ x: trackX2 }}
          className="mt-6 md:mt-10 flex gap-16 will-change-transform font-mono-eyebrow text-[13px] tracking-[0.4em] text-[#0A0A0A]/60"
        >
          {[...Array(24)].map((_, i) => (
            <span key={i} className="flex items-center gap-6 whitespace-nowrap">
              <span className="text-[#C9A961]">◆</span>
              <span>WEBDESIGN · CONTENT · META ADS · PERFORMANCE</span>
            </span>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
}
